import ProgressBar from 'bee-progress-bar'

export default ProgressBar
